import { Activity } from "lucide-react";

// Read-only preview of the measurement sentence + table that will be folded into the letter.
export function MeasurementSourcePreview({ summary, enabled }) {
  if (!summary) return null;
  if (!summary.available) {
    return (
      <p className="text-2xs text-zinc-500 -mt-1 pl-0.5" data-testid="src-measurements-unavailable">
        Needs 2+ assessments with weight or waist recorded.
      </p>
    );
  }
  return (
    <div
      className={`rounded border px-2.5 py-2 text-2xs leading-relaxed transition-opacity ${enabled ? "border-emerald-200 bg-emerald-50/60 text-zinc-700" : "border-zinc-200 bg-zinc-50 text-zinc-400 opacity-70"}`}
      data-testid="src-measurements-preview"
    >
      <div className="flex items-center gap-1.5 text-2xs uppercase tracking-wider text-zinc-500 mb-1">
        <Activity className="h-3 w-3" /> {summary.count} assessments · {summary.first_date} → {summary.last_date}
      </div>
      <p className="italic" data-testid="src-measurements-sentence">“{summary.sentence}”</p>
      <p className="mt-1 text-zinc-500" data-testid="src-measurements-table-note">
        + Measurements table ({summary.metrics.map((m) => m.label).join(", ")})
      </p>
    </div>
  );
}
